(function () {
  'use strict';

  var ROOTS = document.querySelectorAll('[data-skin-diagnostic]');
  if (!ROOTS.length) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var LEAVE_MS = reduceMotion ? 0 : 300;
  var ENTER_MS = reduceMotion ? 0 : 600;
  var SELECT_PAUSE_MS = reduceMotion ? 0 : 420;
  var LOADING_MS = reduceMotion ? 250 : 900;

  var CONCERN_LABELS = {
    hydration: 'hidratación profunda',
    firmness: 'firmeza y antiedad',
    glow: 'luminosidad y tono parejo'
  };

  var MOMENT_LABELS = {
    night: 'tu rutina de noche',
    day: 'retoques rápidos de día',
    all_in_one: 'un solo paso'
  };

  ROOTS.forEach(initDiagnostic);

  function initDiagnostic(root) {
    var dataScript = root.querySelector('script[type="application/json"]');
    var data = { products: [] };
    try {
      data = JSON.parse(dataScript.textContent);
    } catch (e) {
      /* no data, quiz still shows but result step will be skipped */
    }

    var products = (data.products || []).filter(function (p) {
      return p.variantId;
    });

    var screens = {};
    root.querySelectorAll('[data-sd-screen]').forEach(function (el) {
      screens[el.getAttribute('data-sd-screen')] = el;
    });

    var progressWrap = root.querySelector('[data-sd-progress-wrap]');
    var progressFill = root.querySelector('[data-sd-progress-fill]');
    var progressLabel = root.querySelector('[data-sd-progress-label]');

    var order = ['intro', 'q1', 'q2', 'q3', 'loading', 'result'];
    var current = 'intro';
    var answers = {};
    var busy = false;

    function goTo(next) {
      if (busy || !screens[next] || next === current) return;
      busy = true;

      var from = screens[current];
      var to = screens[next];

      updateProgress(next);

      if (LEAVE_MS > 0) {
        from.classList.add('is-leaving');
      }

      window.setTimeout(function () {
        from.hidden = true;
        from.classList.remove('is-leaving', 'is-entering');

        to.hidden = false;
        if (ENTER_MS > 0) {
          to.classList.add('is-entering');
          window.setTimeout(function () {
            to.classList.remove('is-entering');
          }, ENTER_MS);
        }

        var heading = to.querySelector('h1, h2');
        if (heading) {
          if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: false });
        }

        current = next;
        busy = false;
      }, LEAVE_MS);
    }

    function updateProgress(next) {
      var questionIndex = order.indexOf(next);
      var isQuestion = next === 'q1' || next === 'q2' || next === 'q3';

      if (!progressWrap) return;

      if (isQuestion) {
        progressWrap.hidden = false;
        var num = parseInt(next.replace('q', ''), 10);
        progressFill.style.width = (num / 3) * 100 + '%';
        if (progressLabel) progressLabel.textContent = num + ' de 3';
      } else if (next === 'intro') {
        progressWrap.hidden = true;
        progressFill.style.width = '0%';
      } else {
        progressWrap.hidden = true;
      }
    }

    /* ---- start ---- */
    var startBtn = root.querySelector('[data-sd-start]');
    if (startBtn) {
      startBtn.addEventListener('click', function () {
        goTo('q1');
      });
    }

    /* ---- options ---- */
    root.querySelectorAll('[data-sd-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (busy) return;
        var axis = btn.getAttribute('data-axis');
        var value = btn.getAttribute('data-value');
        answers[axis] = value;

        var group = btn.closest('[data-sd-screen]').querySelectorAll('[data-sd-option]');
        group.forEach(function (b) {
          b.classList.toggle('is-selected', b === btn);
        });

        window.setTimeout(function () {
          if (axis === 'concern') goTo('q2');
          else if (axis === 'texture') goTo('q3');
          else if (axis === 'moment') {
            goTo('loading');
            window.setTimeout(function () {
              renderResult(root, products, answers);
              goTo('result');
            }, LOADING_MS);
          }
        }, SELECT_PAUSE_MS);
      });
    });

    /* ---- restart ---- */
    var restartBtn = root.querySelector('[data-sd-restart]');
    if (restartBtn) {
      restartBtn.addEventListener('click', function () {
        answers = {};
        root.querySelectorAll('[data-sd-option].is-selected').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        goTo('intro');
      });
    }
  }

  function scoreProduct(product, answers) {
    var score = 0;

    if (answers.concern && product[answers.concern] === true) {
      score += 3;
    }

    if (answers.texture) {
      var textures = answers.texture.split(',');
      if (textures.indexOf(product.texture) !== -1) {
        score += 3;
      }
    }

    if (answers.moment && product.moment === answers.moment) {
      score += 2;
    }

    return score;
  }

  function renderResult(root, products, answers) {
    if (!products.length) return;

    var scored = products
      .map(function (p) {
        return { product: p, score: scoreProduct(p, answers) };
      })
      .sort(function (a, b) {
        return b.score - a.score;
      });

    var primary = scored[0].product;
    var complement = scored[1] && scored[1].score > 0 ? scored[1].product : null;

    var concernLabel = CONCERN_LABELS[answers.concern] || '';
    var momentLabel = MOMENT_LABELS[answers.moment] || '';

    var headingEl = root.querySelector('[data-sd-result-heading]');
    if (headingEl) {
      headingEl.textContent = 'Para ti: ' + primary.title;
    }

    var img = root.querySelector('[data-sd-primary-image]');
    if (img) {
      if (primary.image) {
        img.src = primary.image;
        img.alt = primary.title;
        img.hidden = false;
      } else {
        img.hidden = true;
      }
    }

    setText(root, '[data-sd-primary-vendor]', primary.vendor || '');
    setText(root, '[data-sd-primary-title]', primary.title);
    setText(root, '[data-sd-primary-price]', primary.price);

    var reasonParts = [];
    if (concernLabel) reasonParts.push('buscas ' + concernLabel);
    if (momentLabel) reasonParts.push('lo vas a usar en ' + momentLabel);
    var reason = reasonParts.length
      ? 'Lo recomendamos porque ' + reasonParts.join(' y ') + '.'
      : '';
    setText(root, '[data-sd-primary-reason]', reason);

    var benefitsList = root.querySelector('[data-sd-primary-benefits]');
    if (benefitsList) {
      benefitsList.innerHTML = '';
      (primary.benefits || []).forEach(function (benefit) {
        var li = document.createElement('li');
        var icon = document.createElement('span');
        icon.setAttribute('aria-hidden', 'true');
        icon.innerHTML =
          '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 9"><path fill="currentColor" fill-rule="evenodd" d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z" clip-rule="evenodd"/></svg>';
        var span = document.createElement('span');
        span.textContent = benefit;
        li.appendChild(icon);
        li.appendChild(span);
        benefitsList.appendChild(li);
      });
    }

    var link = root.querySelector('[data-sd-primary-link]');
    if (link) link.href = primary.url;

    var addBtn = root.querySelector('[data-sd-add-to-cart]');
    if (addBtn) {
      addBtn.disabled = !primary.available;
      var label = addBtn.querySelector('[data-sd-add-label]');
      if (label) label.textContent = primary.available ? 'Agregar al carrito' : 'Agotado';

      addBtn.onclick = function () {
        if (!primary.available || addBtn.dataset.busy === 'true') return;
        addBtn.dataset.busy = 'true';
        if (label) label.textContent = 'Agregando…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: primary.variantId, quantity: 1 }] })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('No se pudo añadir el producto al carrito.');
            return response.json();
          })
          .then(function () {
            if (label) label.textContent = 'Agregado ✓';
            window.setTimeout(function () {
              window.location.assign('/cart');
            }, 400);
          })
          .catch(function (error) {
            addBtn.dataset.busy = 'false';
            if (label) label.textContent = 'Agregar al carrito';
            alert(error && error.message ? error.message : 'No fue posible añadir el producto al carrito.');
          });
      };
    }

    var complementWrap = root.querySelector('[data-sd-complement]');
    if (complementWrap) {
      if (complement) {
        complementWrap.hidden = false;
        var cImg = root.querySelector('[data-sd-complement-image]');
        if (cImg) {
          if (complement.image) {
            cImg.src = complement.image;
            cImg.alt = complement.title;
            cImg.hidden = false;
          } else {
            cImg.hidden = true;
          }
        }
        setText(root, '[data-sd-complement-title]', complement.title);
        setText(root, '[data-sd-complement-price]', complement.price);
        var cLink = root.querySelector('[data-sd-complement-link]');
        if (cLink) cLink.href = complement.url;
      } else {
        complementWrap.hidden = true;
      }
    }
  }

  function setText(root, selector, text) {
    var el = root.querySelector(selector);
    if (el) el.textContent = text || '';
  }
})();
